import type { BoardEdge, BoardSpace } from "@archlang/scene/board";
import { portAsEdge } from "../board/ports.js";

/**
 * Find a board CONNECTION by id anywhere in the (possibly nested) space tree —
 * a sibling arrow or a cross-space port.
 *
 * Ports have to be here because they are selectable: clicking a wall pill
 * selects `port.id` exactly as clicking an arrow selects an edge id. They just
 * aren't stored in `space.edges` — they hang off the item as `externalPorts` —
 * so a resolver that only walked edges left every details surface behind this
 * one saying nothing was selected while the pill sat there highlighted.
 */
export function findBoardEdge(space: BoardSpace | null, id: string): BoardEdge | null {
  if (!space) return null;
  for (const e of space.edges ?? []) if (e.id === id) return e;
  for (const it of space.items) {
    for (const port of it.externalPorts ?? []) {
      if (port.id === id) return portAsEdge(port, it.id);
    }
    if (it.space) {
      const found = findBoardEdge(it.space, id);
      if (found) return found;
    }
  }
  return null;
}
